/*!
 * Vanilla suggester
 * Original author: mercs600
 */


let extend = function (out) {
    out = out || {}
    for (let i = 1; i < arguments.length; i++) {
        if (!arguments[i]) continue
        for (let key in arguments[i]) {
            if (arguments[i].hasOwnProperty(key)) out[key] = arguments[i][key]
        }
    }
    return out
}

class Suggester {
  static _name = 'suggester'

  static _defaults = {
      minLength: 3,
      delay: 300,
      service: '/autosuggest.php',
      phrasesService: '/solarium/ajax/suggest',
      delayTimer: 0
  }


  constructor(containerClass, options) {
    const _ = this
    _.options = extend({}, _.constructor._defaults, options)

    _.$suggester = document.querySelector(containerClass);
    _.$dialog = _.$suggester.querySelector('.suggester__dialog');
    _.$input = _.$suggester.querySelector('input');
    _.$backdrop =  _.$suggester.querySelector('.suggester .backdrop')
    _.searchReset = _.$suggester.querySelector('.search-reset'),
    _.arrowBack = _.$suggester.querySelector('.search-arrow-back')


    _.$DOM = {
      suggests: {
        List: _.$dialog.querySelector('.suggests__list'),
        MostPopular: _.$dialog.querySelector('.suggests__most-popular'),
        Container: _.$dialog.querySelector('.suggests__container'),
        Title: _.$dialog.querySelector('.suggests__title')
      },
      products: {
        List: _.$dialog.querySelector('.products__list'),
        Container: _.$dialog.querySelector('.products__container'),
        Title: _.$dialog.querySelector('.products__title'),
        RightCornerLink: _.$dialog.querySelector('.all-results-link'),
        SpecialOfferLink: _.$dialog.querySelector('.see-more'),
      },
      dialog: {
        Info: _.$dialog.querySelector('.dialog__info'),
        Container: _.$dialog
      }
    }

    _.lastSearched = ''


    _.init()
    _.loadSuggesterPhrases()
  }

  init() {
      const _ = this

      _.$input.addEventListener('focusin', _.onFocus.bind(_))
      _.$input.addEventListener('keyup', _.onPress.bind(_))
      _.$backdrop.addEventListener('click', _.suggesterToggle.bind(_, false))
      _.searchReset.addEventListener('click', _.resetForm.bind(_))
      _.arrowBack.addEventListener('click', _.suggesterToggle.bind(_, false))
  }

  loadSuggesterPhrases() {
    const _ = this,
    req = new XMLHttpRequest();

    req.onreadystatechange = function () {

      if (req.readyState === 4) {
        let parsedResponse = null
        try {
            parsedResponse = JSON.parse(req.response)
        } catch (e) {
            console.error(e)
        }

        if (parsedResponse) {
          const isNotEmpty = Object.keys(parsedResponse).length > 0
          if (isNotEmpty) {
            _.isPhrasesDataLoaded = true
            _.phrasesData = parsedResponse
          }
          else {
            _.isPhrasesDataLoaded = false
          }
        }
      }
    }
    req.open("GET", _.options.phrasesService, true);
    req.send();
  }

  // Events handlers

  onPress(e) {

    const _ = this,
          enteredText = e.target.value

    if (e.keyCode === 27) {
      return _.suggesterToggle(false)
    }

    _.onInput(enteredText)

  }

  onFocus(e) {
    const _ = this
    const inputText = _.$input.value
    _.suggesterToggle(true)
    _.onInput(_.$input.value)


    if (this.isPhrasesDataLoaded && inputText.length < 1) {
      if (!_.phrasesLoadedinSuggester) {
        _.formatSuggesterPhrases(this.phrasesData)
        _.phrasesLoadedinSuggester = true
      }
      _.dialogToggle(true)
    }
  }

  onInput(text) {
    const _ = this

    if (text.length > 0) {
      _.searchReset.classList.remove('hidden')
      _.$dialog.classList.remove('phrases-visible')
    }
    else {
      _.searchReset.classList.add('hidden')
    }

    if (
      text !== _.lastSearched &&
      text.length >= _.options.minLength &&
      _.isFocused
      ) {
      _.lastSearched = text
      _.delayedQuery(text)
    }

    if (text.length === 0) {
      _.$DOM.dialog.Container.classList.remove('suggester__dialog--no-results')
      //_.dialogToggle(false)
    }
  }

  // Utils

  query(q) {
      const _ = this,
          params = '?q=' + q

      _.loaderToggle(true)
      const ajax = new XMLHttpRequest()
      const autoSuggestHeader = window.JSAPP_CONFIG.HTTP_ACCEPT
      ajax.onreadystatechange = function () {
          if (ajax.readyState === 4) {
              let parsedResponse = null
              try {
                  parsedResponse = JSON.parse(ajax.response)
              } catch (e) {
                  console.error(e)
              }

              if (parsedResponse) {
                  _.format(parsedResponse)
              }

              _.loaderToggle(false)
          }
      }
      ajax.open('GET', _.options.service + params, true)
      ajax.setRequestHeader('accept', autoSuggestHeader)
      ajax.send()
  }

  delayedQuery(q) {
    const _ = this

    if (_.options.delayTimer) {
      clearTimeout(_.options.delayTimer)
    }
    _.options.delayTimer = setTimeout(function () {
        _.query(q)
    }, _.options.delay)
  }

  resetForm() {
    const _ = this

    const inputFields = document.querySelectorAll('.input-top-search')
    inputFields.forEach((input) => {
      input.value = ''
    })

    _.$input.focus()
    _.searchReset.classList.add('hidden')

    _.onInput('')
    _.resetSuggesterData()
    if (this.isPhrasesDataLoaded) {
      _.formatSuggesterPhrases(this.phrasesData)
      _.phrasesLoadedinSuggester = true
    }
    else {
      _.dialogToggle(false)
    }
  }

  specialOfferProducts(productsData, offerLink, title) {
    let _ = this,
        { products } = _.$DOM
    const offerUrl = '/catalogsearch/result?q=' + encodeURI(offerLink)
    products.Title.innerHTML = title
    products.SpecialOfferLink.setAttribute('href', offerUrl)

    productsData.forEach((product) => {
      let specialOfferItem = document.createElement('li')
      specialOfferItem.classList.add(
        'suggester__item',
        'col-lg-2',
        'col-sm-3'
    )
    specialOfferItem.innerHTML =
      '<div><a href="'+product.url+'"><div class="product-simple__img"><img src="'+product.image+'"/></div><p class="product-simple__name text-elipsis text-elipsis--3">'+product.name+'</p><span>'+product.price+' zł </span></a></div>'
    products.List.appendChild(specialOfferItem)
    });
  }

  formatSuggesterPhrases(data) {
    let _ = this,
        phrases = Object.keys(data),
        { products, suggests, dialog } = _.$DOM

    _.$dialog.classList.add('phrases-visible')
    suggests.Title.innerHTML = 'Popularne wyszukiwania'

    if (data.promotions) {
      const specialOffer = data.promotions.products,
        specialOfferTitle = data.promotions.title,
        specialOfferQuery = data.promotions.title,
        specialOfferHasProducts = specialOffer.length > 0

      if (specialOfferHasProducts) {
        _.specialOfferProducts(specialOffer, specialOfferQuery, specialOfferTitle)
        products.Container.style.display = 'block'
      }
    }
    else {
      products.Container.style.display = 'none'
    }

    suggests.Container.style.display = 'block'
    phrases.forEach((phrase) => {
      let resultItem = document.createElement('li'),
          resultLink = document.createElement('a'),
          resultLinkText = document.createElement('span')

      resultLinkText.innerHTML = phrase
      let phraseText = resultLink.innerText
      resultLink.setAttribute('href', '/catalogsearch/result?q=' + encodeURI(phrase))
      if (phrase === 'promotions') {
        resultItem.classList.add('suggests-promotions')
      }

      resultLink.appendChild(resultLinkText)
      resultItem.appendChild(resultLink)
      suggests.List.appendChild(resultItem)


      if (window.innerWidth > 992) {
        resultLinkText.addEventListener('mouseenter', function (){
          products.List.innerHTML = ''
          const phraseProducts = data[phrase].products
          if (phraseProducts.length > 0) {
            _.specialOfferProducts(phraseProducts, phrase, phrase)
            products.Container.style.display = 'block'
          }
          else {
            products.Container.style.display = 'none'
          }
        })
      }
    });

    _.dialogToggle(true)
  }

  format(data) {
      let _ = this,
          hasSuggestions = data.suggestions.length > 0,
          hasProducts = data.products && data.products.length > 0,
          { products, suggests, dialog } = _.$DOM

      products.List.innerHTML = ''
      suggests.List.innerHTML = ''

     suggests.List.addEventListener('click', _.handleSuggestClick.bind(_))

      if (!hasProducts && !hasSuggestions) {
        dialog.Info.innerHTML = 'Brak wyników wyszukiwania. Wpisz inną frazę.'
        dialog.Container.classList.add('suggester__dialog--no-results')
      } else {
        dialog.Info.innerHTML = ''
        dialog.Container.classList.remove('suggester__dialog--no-results')
      }

      if (!hasSuggestions) {
        suggests.Container.style.display = 'none'
      } else {
        suggests.Container.style.display = 'block'
        suggests.Title.innerHTML = 'Popularne frazy'

        data.suggestions.forEach(function (suggestion) {
            let resultItem = document.createElement('li'),
                resultLink = document.createElement('a')

            resultLink.innerHTML = suggestion

            let suggestionText = resultLink.innerText
            resultLink.setAttribute('href', '/catalogsearch/result?q=' + encodeURI(suggestionText))

            resultItem.appendChild(resultLink)

            suggests.List.appendChild(resultItem)
        })
      }

      if (data.all_results && products.RightCornerLink) {
          products.RightCornerLink.setAttribute('href', data.all_results.url)
          products.RightCornerLink.textContent = data.all_results.label
      }

      if (!hasProducts) {
        products.Container.style.display = 'none'
      } else {
        products.Container.style.display = 'block'
        products.Title.innerHTML = 'Popularne produkty'

        for (let i = 0; i < data.products.length; i++) {
            let SuggesterItem = document.createElement('li')
            SuggesterItem.classList.add(
                'suggester__item',
                'col-lg-3',
                'col-sm-6'
            )
            SuggesterItem.innerHTML = data.products[i]
            products.List.appendChild(SuggesterItem)
            staticImpressions['suggester-' + data.analytics[i].id] =
                data.analytics[i]
        }
      }

      if (
          typeof GoogleAnalyticsUniversal !== 'undefined' &&
          data.analytics.length &&
          typeof Object.setPrototypeOf !== 'undefined'
      ) {
          const impression = Object.setPrototypeOf(
              data.analytics,
              Object.prototype
          )
          GoogleAnalyticsUniversal.prototype.pushImpressions(impression)
          GoogleAnalyticsUniversal.prototype.listenImpressionClick()
      }

      return _.dialogToggle(true)
  }

  resetSuggesterData() {
    const _ = this,
          {products, suggests } = _.$DOM

    products.List.innerHTML = ''
    suggests.List.innerHTML = ''
    _.phrasesLoadedinSuggester = false
  }

  dialogToggle(show) {
      if (show && this.isFocused) {
          this.$suggester.classList.add('has-results')
          this.$dialog.style.display = 'block'
      } else {
          this.$suggester.classList.remove('has-results')
          this.$dialog.style.display = 'none'
      }
  }

  loaderToggle(show) {
    this.$suggester.querySelector('.loader').classList.toggle('hidden', !show)
  }

  suggesterToggle(show) {
    const _ = this,
      inputText = _.$input.value

    if (show) {
        document.documentElement.classList.add('suggester-is-focus')
        _.$suggester.classList.add('is-focus', 'backdrop-is-visible')
        _.isFocused = true

    } else {
        document.documentElement.classList.remove('suggester-is-focus')
        _.$suggester.classList.remove('is-focus', 'backdrop-is-visible')
        _.$suggester.querySelector('input').blur()
        _.isFocused = false
        _.dialogToggle(false)
        _.loaderToggle(false)

        if(inputText.length < 1) {
          _.resetSuggesterData()
        }
    }
  }


  handleSuggestClick(e) {
    const _ = this

    if (e.target.tagName === 'A') {
      e.preventDefault()

      const suggestionText = e.target.innerText

      _.$input.value = suggestionText
      _.suggesterToggle(false)
      window.location.href = e.target.href
    }
  }
}
// make accessible globally
window.Suggester = Suggester
export default Suggester
